// extracted by mini-css-extract-plugin
export default {"loader":"circleCompleteLoader_loader__yxNPH","l11":"circleCompleteLoader_l11__dXe2F"};